// "Cargar más productos": acrescenta a página seguinte na mesma grade.
// Como na Vivara, carrega sozinho quando a cliente chega ao fim da grade
// (o botão entra na tela); o clique no botão faz o mesmo, e sem JavaScript o
// botão é só um link para a página seguinte (snippets/cargar-mas.liquid).
// Delegação e MutationObserver porque o filtro (facets.js) re-renderiza a
// seção inteira e troca o botão.
if (!window.__cargarMas) {
  window.__cargarMas = true;

  const carregar = async (botao) => {
    if (botao.getAttribute('aria-busy') === 'true') return;
    const grade = document.getElementById('product-grid');
    const bloco = botao.closest('.cargar-mas');
    botao.setAttribute('aria-busy', 'true');
    botao.textContent = botao.dataset.textoCarregando || '…';

    try {
      const url = new URL(botao.href, location.origin);
      url.searchParams.set('section_id', botao.dataset.sectionId);
      const html = await (await fetch(url)).text();
      const pagina = new DOMParser().parseFromString(html, 'text/html');
      pagina.querySelectorAll('#product-grid > .grid__item').forEach((item) => {
        // a animação de entrada depende de um observer que não vê itens novos
        item.classList.remove('scroll-trigger', 'animate--slide-in');
        grade.appendChild(item);
      });
      const proximo = pagina.querySelector('.cargar-mas');
      if (proximo) bloco.replaceWith(proximo);
      else bloco.remove();
    } catch (erro) {
      // falhou a busca: segue o link, como a paginação faria
      location.href = botao.href;
    }
  };

  document.addEventListener('click', (evento) => {
    const botao = evento.target.closest('.cargar-mas__botao');
    if (!botao) return;
    evento.preventDefault();
    carregar(botao);
  });

  // Rolagem infinita: 600 px antes do botão aparecer, já começa a buscar.
  // Botão acima da tela também conta (margem de cima enorme): um salto ao fim
  // (tecla End, arrastar a barra) passa por cima dele sem cruzar a tela, e o
  // observer só avisa quando o estado muda.
  if ('IntersectionObserver' in window) {
    const observador = new IntersectionObserver(
      (entradas) => entradas.forEach((e) => e.isIntersecting && carregar(e.target)),
      { rootMargin: '100000px 0px 600px 0px' }
    );
    const vigiar = () => document.querySelectorAll('.cargar-mas__botao:not([data-vigiado])').forEach((b) => {
      b.dataset.vigiado = '';
      observador.observe(b);
    });
    vigiar();
    new MutationObserver(vigiar).observe(document.body, { childList: true, subtree: true });
  }
}
